/**
 * Minifigs 2.0 - Apply torso image overlay to product media gallery items
 *
 *
 * @author Benjamin Wilson <benjamin.wilson@four.agency>
 * @package Joi Polloi
 */

const buyBitsFormTorsoOverlay = () => {
    const imageOverlayFormElements = Array.from(document.querySelectorAll('#buyBitsFormTorsoOverlay'));
    if (!imageOverlayFormElements || imageOverlayFormElements.length === 0) return;
    const variantIds = imageOverlayFormElements.map((item) => item.dataset.productVariantId);

    const getMetafield = async () => {
        try {
            const resp = await fetch('/api/2025-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'Access-Control-Origin': '*',
                    'X-Shopify-Storefront-Access-Token': 'e14901ef020f42eff2b10fbed13e6e18',
                },
                body: query(variantIds),
            });

            return await resp.json();
        } catch (err) {
            console.log('Fetch Error :-S', err);
        }
    };

    getMetafield().then((res) => {
        const variants = res.data.nodes;

        imageOverlayFormElements.forEach((item) => {
            const variant = variants.find(
                (v) => v?.id === `gid://shopify/ProductVariant/${item.dataset.productVariantId}`
            );
            const overlayStyle = variant.torsoOverlayValue?.value === 'Light' ? 'Colour-Artwork' : 'Dark-Artwork';
            const overlayImage = variant.product.images.edges.find((image) => image.node.url.includes(overlayStyle));
            const overlaySrc = overlayImage.node.url;
            item.setAttribute('value', overlaySrc);
        });
    });
};

const hiddenIdInput = document.querySelectorAll('.js-but-bits-product-form input[name="id"]');
hiddenIdInput.forEach((selectElement) => {
    selectElement.addEventListener('change', (e) => {
        const imageOverlayFormElements = Array.from(document.querySelectorAll('#buyBitsFormTorsoOverlay'));
        imageOverlayFormElements.forEach((item) => {
            item.dataset.productVariantId = e.target.value;
        });
        buyBitsFormTorsoOverlay();
    });
});

export default buyBitsFormTorsoOverlay;

const query = (variantIds) => {
    const formattedIds = variantIds.map((id) => `gid://shopify/ProductVariant/${id}`);
    return `{
        nodes(ids: ${JSON.stringify(formattedIds)}) {
            ... on ProductVariant {
                id
                torsoOverlayValue: metafield(
                        namespace: "custom"
                        key: "torso_overlay"
                    ) {
                        value
                    }
                product {
                    id
                    images(first: 200) {
                        edges {
                            node {
                                url
                            }
                        }
                    }
                }
            }
        }
    }`;
};
